<template>
    <div class="searchCategory" style="margin-top: 10px">
        <el-select style="width: 100%" v-model="setTingObj.selectConfig.val" placeholder="请选择" clearable size="small" @change="change">
            <el-tree node-key="id" :default-expanded-keys="expandss" :data="shopCategoryIds" :props="treeProps">
                <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                    <el-option :label="node.label" :value="data.id"> </el-option>
                </div>
            </el-tree>
        </el-select>
    </div>
</template>

<script>
import { get } from '@/utils/request.js';
export default {
    data(){
        return{
            category: null,
            expandss: [],
            shopCategoryIds: [],
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
        }
    },
    props:{
        setTingObj:{
            type: Object,
            default: {}
        }
    },
    created() {
        this.getCategoryList();
    },
    methods:{
        getCategoryList() {
            get('/shop/productcategory/findAllAsTree').then((res)=>{
                if(res.success){
                    this.shopCategoryIds = res.treeData;
                    res.treeData.forEach((element) => {
                        this.expandss.push(element.id);
                    });
                }
            })
        },
        change(e){
            if(e){
                get('/shop/product/findList',{
                    categoryId: e,
                    pageSize: this.setTingObj.numConfig.val,
                    pageNum: 1
                }).then((res)=>{
                    if(res.success){
                        this.setTingObj.goodsList.list = []
                        res.page.list.forEach((item)=>{
                            this.setTingObj.goodsList.list.push({
                                id: item.id,
                                name: item.productName,
                                pic: item.productPic,
                                oprice: item.marketPrice,
                                price: item.shopPrice
                            })
                        })
                    }
                })
            } else {
                this.setTingObj.goodsList.list = [{
                    id: "",
                    name: "小米智能保温杯Ti2商务便携男女士大容量茶杯纯钛茶水分离杯w847",
                    pic: "",
                    oprice: "99",
                    price: "79"
                }]
            }
        }
    }
}
</script>

<style scoped lang="scss">
.searchCategory{
    width: 100%;
}
</style>